import { Decimal } from 'decimal.js';
import { Fraction } from 'fractional';
import { CATALOG } from '../constants';
import { UD_TYPES } from './constants';

export const toFraction = (decimal: number, precisionAndDenominator: number = 16) => {
  const dec = Math.round(decimal * precisionAndDenominator) / precisionAndDenominator; // INFO: Calculate decimal by precision and denominator
  const absDec = Math.abs(dec); // INFO: Convert to positive value

  return new Fraction(absDec).toString();
};

export const compose = (...fns) =>
  fns.reduceRight(
    (f, g) =>
      (...args) =>
        g(f(...args))
  );

export const throwError = (message = 'Wrong udType parameter') => {
  throw new Error(message);
};

export const isCatalogUSA = (catalogId: number) => catalogId === CATALOG.USA;
export const isCatalogINT = (catalogId: number) => catalogId === CATALOG.INT;

const isPlural = (n: number) => n !== 1;
export const getUdDescriptionInGrammarTypeByLang = (value: number, udDescriptionByLang) =>
  isPlural(value) ? udDescriptionByLang?.plural : udDescriptionByLang?.singular;

export const toDecimalPlaces = (value: number, decimals: number) => Number(new Decimal(value).toDP(decimals));

// INFO: Decimal places per unit so accumulated float errors (e.g. 1561.3999999999999)
// don't leak into rendered values/descriptions. Lumens are whole numbers; watts keep 2 decimals.
const UD_DECIMALS: Partial<Record<UD_TYPES, number>> = {
  [UD_TYPES.LUMENS]: 0,
  [UD_TYPES.WATTS]: 2,
};

export const roundByUdType = (value: number, udType: string): number => {
  const decimals = UD_DECIMALS[udType as UD_TYPES];
  if (decimals === undefined || typeof value !== 'number' || !Number.isFinite(value)) {
    return value;
  }
  return toDecimalPlaces(value, decimals);
};
